import { LendContract, Lending, PriceList, Token } from '@jdiyield/interfaces'
import Web3 from 'web3'

import { getAlpacaLending } from './platforms/alpaca'
import { getIronLending } from './platforms/iron'
import { getMaiFinanceVault } from './platforms/maiFinance'
import { getVenusLending } from './platforms/venus'

export const queryLending = async (
  web3: Web3,
  walletAddress: string,
  lendContract: LendContract,
  tokens: Token[],
  priceList: PriceList
): Promise<Lending> => {
  switch (lendContract.id) {
    case 'Iron Lending':
      return await getIronLending(web3, walletAddress, lendContract, tokens, priceList)
    case 'Venus Lending':
      return await getVenusLending(web3, walletAddress, lendContract, tokens, priceList)
    case 'Alpaca Lending':
      return await getAlpacaLending(web3, walletAddress, lendContract, tokens, priceList)
    case 'Mai Finance Vault':
      return await getMaiFinanceVault(web3, walletAddress, lendContract, tokens, priceList)
    default:
      break
  }
  return {
    collateralTokens: [],
    borrowBalance: 0,
    borrowTokens: [],
    supplyBalance: 0
  }
}
